import Vue from "vue";
import VueRouter from "vue-router";
import Ilmoitustaulu from "@/views/Ilmoitustaulu";
import Login from "@/views/Login";
import store from "@/store/index";
import * as Sentry from "@sentry/vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/ilmoitustaulu",
    nav: false,
  },
  {
    path: "/ilmoitustaulu",
    name: "Ilmoitustaulu",
    label: "Ilmoitustaulu",
    component: Ilmoitustaulu,
    category: "Yleinen",
    icon: "mdi-view-dashboard",
  },
  {
    path: "/hallitus",
    name: "Hallitus",
    label: "Hallitus",
    component: () =>
      import(
        /* webpackChunkName: "view-hallitus" */ "@/views/IlmoitustauluHallitus.vue"
      ),
    roles: ["hallitus"],
    category: "Yleinen",
    icon: "mdi-gavel",
  },
  {
    path: "/asetukset",
    name: "Asetukset",
    label: "Asetukset",
    component: () =>
      import(/* webpackChunkName: "view-settings" */ "@/views/Asetukset.vue"),
    nav: false,
    icon: "mdi-cog",
  },
  {
    path: "/login",
    name: "Login",
    label: "Sisäänkirjautuminen",
    component: Login,
    nav: false,
  },
  {
    path: "/harjoitukset",
    name: "Harjoitukset",
    label: "Harjoitukset",
    component: () =>
      import(
        /* webpackChunkName: "view-harjoitukset" */ "@/views/Harjoitukset.vue"
      ),
    roles: ["user", "admin"],
    category: "Hälytysosasto",
    icon: "mdi-fire-truck",
  },
  {
    path: "/harjoitussuunnitelmat",
    name: "Harjoitussuunnitelmat",
    label: "Harjoitussuunnitelmat",
    component: () =>
      import(
        /* webpackChunkName: "view-harjoitussuunnitelmat" */ "@/views/Harjoitussuunnitelmat.vue"
      ),
    roles: ["admin"],
    category: "Hälytysosasto",
    icon: "mdi-calendar-clock",
  },
  {
    path: "/harjoitussuunnitelma",
    name: "Harjoitussuunnitelma",
    label: "Harjoitussuunnitelma",
    component: () =>
      import(
        /* webpackChunkName: "view-harjoitussuunnitelma" */ "@/views/Harjoitussuunnitelma.vue"
      ),
    roles: ["user", "admin"],
    nav: false,
  },
  {
    path: "/turvallisuusilmoitus",
    name: "Turvallisuusilmoitus",
    label: "Turvallisuusilmoitus",
    component: () =>
      import(
        /* webpackChunkName: "view-turvallisuus" */ "@/views/Vaaratilannehavainto.vue"
      ),
    category: "Yleinen",
    icon: "mdi-alert",
  },
  {
    path: "/tiedostopankki",
    name: "Tiedostopankki",
    label: "Tiedostopankki",
    component: () =>
      import(
        /* webpackChunkName: "view-tiedostopankki" */ "@/views/Tiedostopankki.vue"
      ),
    roles: ["user"],
    category: "Yleinen",
    icon: "mdi-folder",
  },
  {
    path: "/kululaskut",
    name: "Kululaskut",
    label: "Kululaskut",
    component: () =>
      import(/* webpackChunkName: "view-kululaskut" */ "@/views/Kululaskut.vue"),
    roles: ["user"],
    category: "Yleinen",
    icon: "mdi-receipt",
  },
  {
    path: "/budjetti",
    name: "Budjetti",
    label: "Budjetti",
    redirect: "/hallitus?tab=budjetti",
    roles: ["hallitus"],
    category: "Yleinen",
    icon: "mdi-calculator",
    nav: false,
  },
  {
    path: "/kululaskut/uusi",
    name: "UusiKululasku",
    component: () =>
      import(
        /* webpackChunkName: "view-kululaskut" */ "@/views/ExpenseClaimEdit.vue"
      ),
    roles: ["user"],
    nav: false,
  },
  {
    path: "/kululaskut/:id",
    name: "ExpenseClaimEdit",
    component: () =>
      import(
        /* webpackChunkName: "view-kululaskut" */ "@/views/ExpenseClaimEdit.vue"
      ),
    roles: ["user"],
    nav: false,
  },
  {
    path: "/ilmoitustaulu/ilmoitus/",
    name: "Ilmoitus",
    label: "Ilmoitus",
    component: () =>
      import(/* webpackChunkName: "view-ilmoitus" */ "@/views/Ilmoitus.vue"),
    nav: false,
  },
  {
    path: "/ilmoitustaulu/ilmoitus/:id",
    name: "IlmoitusById",
    component: () =>
      import(/* webpackChunkName: "view-ilmoitus" */ "@/views/Ilmoitus.vue"),
    nav: false,
  },
  {
    path: "/lainaus",
    name: "Lainaus",
    label: "Lainaus",
    component: () =>
      import(/* webpackChunkName: "view-lainaus" */ "@/views/Lainaus.vue"),
    roles: ["user", "naisosasto"],
    category: "Yleinen",
    icon: "mdi-hand-coin",
  },
  {
    path: "/kalusto",
    name: "Kalusto",
    label: "Kalusto",
    component: () =>
      import(/* webpackChunkName: "view-kalusto" */ "@/views/Kalustonhuolto.vue"),
    roles: ["user"],
    category: "Hälytysosasto",
    icon: "mdi-tools",
  },
  {
    path: "/kalusto/:id",
    name: "KalustoById",
    component: () =>
      import(/* webpackChunkName: "view-kalusto" */ "@/views/KalustoEditView.vue"),
    nav: false,
  },
  {
    path: "/tarveilmoitukset",
    name: "Tarveilmoitukset",
    label: "Tarveilmoitukset",
    component: () =>
      import(
        /* webpackChunkName: "view-kalusto" */ "@/views/KalustoTarveilmoituksetView.vue"
      ),
    roles: ["user"],
    category: "Hälytysosasto",
    icon: "mdi-clipboard-alert-outline",
  },
  {
    path: "/leirikoski",
    name: "Leirikoski",
    label: "Leirikoski",
    component: () =>
      import(/* webpackChunkName: "view-leirikoski" */ "@/views/Leirikoski.vue"),
    roles: ["user", "naisosasto"],
    category: "Yleinen",
    icon: "mdi-home-group",
  },
  {
    path: "/leirikoski/vihko/uusi",
    name: "LeirikoskiVihkoNew",
    component: () =>
      import(
        /* webpackChunkName: "view-leirikoski" */ "@/views/LeirikoskiVihkoEdit.vue"
      ),
    roles: ["user", "naisosasto"],
    nav: false,
  },
  {
    path: "/leirikoski/vihko/:id",
    name: "LeirikoskiVihkoEdit",
    component: () =>
      import(
        /* webpackChunkName: "view-leirikoski" */ "@/views/LeirikoskiVihkoEdit.vue"
      ),
    roles: ["user", "naisosasto"],
    nav: false,
  },
  {
    path: "/tehtavat",
    name: "Tehtävät",
    label: "Tehtävät",
    component: () =>
      import(/* webpackChunkName: "view-tehtavat" */ "@/views/Tehtavat.vue"),
    nav: true,
    roles: ["user"],
    category: "Yleinen",
    icon: "mdi-clipboard-list",
  },
  {
    path: "/aloite",
    name: "Aloiteboksi",
    label: "Aloiteboksi",
    component: () =>
      import(/* webpackChunkName: "view-aloite" */ "@/views/Aloite.vue"),
    roles: ["user", "naisosasto"],
    category: "Yleinen",
    icon: "mdi-lightbulb",
  },
  {
    path: "/linkit",
    name: "Linkit",
    label: "Linkit",
    component: () =>
      import(/* webpackChunkName: "view-linkit" */ "@/views/Linkit.vue"),
    roles: ["user"],
    category: "Hälytysosasto",
    icon: "mdi-link",
  },
  {
    path: "/ajoneuvotiedot",
    name: "Ajoneuvotiedot",
    label: "Ajoneuvotiedot",
    component: () =>
      import(
        /* webpackChunkName: "view-ajoneuvotiedot" */ "@/views/Ajoneuvotiedot.vue"
      ),
    roles: ["user"],
    category: "Hälytysosasto",
    icon: "mdi-car-search",
  },
  {
    path: "/kemikaalitiedot",
    name: "Kemikaalitiedot",
    label: "Kemikaalitiedot",
    component: () =>
      import(
        /* webpackChunkName: "view-kemikaalitiedot" */ "@/views/Kemikaalitiedot.vue"
      ),
    roles: ["user"],
    category: "Hälytysosasto",
    icon: "mdi-flask",
  },
  {
    path: "/pelastuskorttitietokanta",
    name: "PelastuskorttiTietokanta",
    label: "Pelastuskorttitietokanta",
    component: () =>
      import(
        /* webpackChunkName: "view-pelastuskortti" */ "@/views/PelastuskorttiTietokanta.vue"
      ),
    roles: ["user"],
    category: "Hälytysosasto",
    icon: "mdi-database-search",
    nav: false,
  },
  {
    path: "/ensivaste-ohjeet",
    name: "Ensivaste-ohjeet",
    label: "Ensivaste-ohjeet",
    component: () =>
      import(
        /* webpackChunkName: "view-ensivaste" */ "@/views/EnsivasteOhjeet.vue"
      ),
    roles: ["user"],
    category: "Hälytysosasto",
    icon: "mdi-heart-pulse",
  },
  {
    path: "/kartta",
    name: "Kartta",
    label: "Kartta",
    component: () =>
      import(/* webpackChunkName: "view-kartta" */ "@/views/MapView.vue"),
    roles: ["user"],
    category: "Yleinen",
    icon: "mdi-map",
  },
  {
    path: "/digivihot",
    name: "Digivihot",
    label: "Digivihot",
    component: () =>
      import(/* webpackChunkName: "view-digivihko" */ "@/views/Digivihot.vue"),
    roles: ["admin"],
    category: "Hälytysosasto",
    icon: "mdi-notebook",
  },
  {
    path: "/digivihot/d/:id",
    name: "DigivihkoById",
    component: () =>
      import(/* webpackChunkName: "view-digivihko" */ "@/views/Digivihko.vue"),
    nav: false,
  },
  {
    path: "/digivihot/d/",
    name: "Digivihko",
    label: "Digivihko",
    component: () =>
      import(/* webpackChunkName: "view-digivihko" */ "@/views/Digivihko.vue"),
    nav: false,
  },
  {
    path: "/henkilot",
    name: "Henkilöt",
    label: "Henkilöt",
    component: () =>
      import(/* webpackChunkName: "view-henkilot" */ "@/views/Henkilot.vue"),
    part: "system",
    roles: ["superAdmin"],
    category: "Hälytysosasto",
    icon: "mdi-account-multiple",
  },
  {
    path: "/tukiosaston-henkilot",
    name: "Tukiosaston Henkilöt",
    label: "Tukiosaston Henkilöt",
    component: () =>
      import(
        /* webpackChunkName: "view-tukiosasto" */ "@/views/TukiosastonHenkilot.vue"
      ),
    part: "system",
    roles: ["superAdmin", "naisosasto"],
    category: "Tukiosasto",
    icon: "mdi-account-group-outline",
  },
  {
    path: "/tukiosaston-harjoitukset",
    name: "Tukiosaston Harjoitukset",
    label: "Tukiosaston Harjoitukset",
    component: () =>
      import(
        /* webpackChunkName: "view-tukiosasto" */ "@/views/TukiosastonHarjoitukset.vue"
      ),
    part: "system",
    roles: ["superAdmin", "naisosasto"],
    category: "Tukiosasto",
    icon: "mdi-calendar-check",
  },
  {
    path: "/kayttajat",
    name: "Käyttäjät",
    label: "Käyttäjät",
    component: () =>
      import(/* webpackChunkName: "view-kayttajat" */ "@/views/Kayttajat.vue"),
    part: "system",
    roles: ["superAdmin"],
    category: "Muu",
    icon: "mdi-account-cog",
  },
  {
    path: "/raportointi",
    name: "Raportointi",
    label: "Raportointi",
    component: () =>
      import(/* webpackChunkName: "view-raportointi" */ "@/views/Raportointi.vue"),
    part: "system",
    roles: ["superAdmin"],
    category: "Muu",
    icon: "mdi-chart-bar",
  },
  {
    path: "/hallitus/ilmoitus/",
    name: "HallitusIlmoitus",
    label: "HallitusIlmoitus",
    component: () =>
      import(
        /* webpackChunkName: "view-hallitus" */ "@/views/IlmoitusHallitus.vue"
      ),
    nav: false,
  },
  {
    path: "/hallitus/ilmoitus/:id",
    name: "HallitusIlmoitusById",
    component: () =>
      import(
        /* webpackChunkName: "view-hallitus" */ "@/views/IlmoitusHallitus.vue"
      ),
    nav: false,
  },
  {
    path: "/hallitus/mallitehtavat",
    name: "HallitusMalliTehtavat",
    component: () =>
      import(
        /* webpackChunkName: "view-hallitus" */ "@/views/TehtavaMallitHallitus.vue"
      ),
    nav: false,
  },
  {
    path: "/muonitus",
    name: "Muonitus",
    label: "Muonitus",
    component: () =>
      import(/* webpackChunkName: "view-muonitus" */ "@/views/Muonitus.vue"),
    roles: ["admin", "naisosasto"],
    part: "system",
    category: "Tukiosasto",
    icon: "mdi-food",
  },
  {
    path: "/muonitus/pohjat",
    name: "MuonitusPohjat",
    component: () =>
      import(/* webpackChunkName: "view-muonitus" */ "@/views/MuonitusPohjat.vue"),
    roles: ["admin", "naisosasto"],
    nav: false,
  },
  {
    path: "/muonitus/asetukset",
    name: "MuonitusAsetukset",
    component: () =>
      import(
        /* webpackChunkName: "view-muonitus" */ "@/views/MuonitusAsetukset.vue"
      ),
    roles: ["admin", "naisosasto"],
    nav: false,
  },
  {
    path: "/muonitus/:id",
    name: "MuonitusTapahtuma",
    component: () =>
      import(
        /* webpackChunkName: "view-muonitus" */ "@/views/MuonitusTapahtuma.vue"
      ),
    roles: ["admin", "naisosasto"],
    nav: false,
  },
  {
    path: "/jasentietolomakkeet",
    name: "Jäsentietolomakkeet",
    component: () =>
      import(
        /* webpackChunkName: "view-jasenlomakkeet" */ "@/views/MemberFormsAdmin.vue"
      ),
    label: "Jäsentietolomakkeet",
    roles: ["osastonjohtaja", "hallitus"],

    category: "Hallinto",
    icon: "mdi-file-document-multiple",
  },
  {
    path: "/lomake/:token",
    name: "PublicMemberForm",
    component: () =>
      import(
        /* webpackChunkName: "view-public-lomake" */ "@/views/PublicMemberForm.vue"
      ),
    nav: false,
  },
  {
    path: "/kauppalista/:id",
    name: "PublicShoppingList",
    component: () =>
      import(
        /* webpackChunkName: "view-public-kauppalista" */ "@/views/PublicShoppingList.vue"
      ),
    nav: false,
  },
  {
    path: "/harjoitukset-naytto/:token",
    name: "PublicHarjoitukset",
    component: () =>
      import(
        /* webpackChunkName: "view-public-harjoitukset" */ "@/views/PublicHarjoitukset.vue"
      ),
    nav: false,
  },
];
let prev = null;
const router = new VueRouter({
  routes,
});
if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    Vue,
    dsn: "https://47af7474a1e459e439f8d2cfec87e750@o4508513812545536.ingest.de.sentry.io/4508513816215632",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      // Sentry.replayIntegration disabled for startup performance
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/app.noormarkunvpk\.fi/],
    // Session Replay disabled for startup performance
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}
router.beforeEach((to, from, next) => {
  if (
    to.name !== "Login" &&
    to.name !== "PublicShoppingList" &&
    to.name !== "PublicMemberForm" &&
    to.name !== "PublicHarjoitukset" &&
    !store?.state.user
  ) {
    next({ name: "Login" });
  } else {
    next((vm) => {
      prev = from;
    });
  }
});
export { routes };
export default router;
